import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { ProdOrder } from '../../prod-order'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { ProdOrderTransitDetailComponent } from '../../../transit/prod-order-transit-detail/prod-order-transit-detail.component'
import { AsyncPipe } from '@angular/common'
import { ProdOrderTransitBrowserComponent } from '../../../transit/prod-order-transit-browser/prod-order-transit-browser.component'
import {
  ElderBasicPaneLayoutComponent,
  ElderPaneComponent,
  ElderPaneContentComponent,
  ElderPaneHeaderComponent,
  ElderPaneTitleComponent,
} from '@elderbyte/ngx-starter'
import { ProdOrderTransit, TransitAssignment } from '../../../transit/prod-order-transit'

@Component({
  selector: 'app-prod-order-dispatch',
  templateUrl: './prod-order-dispatch.component.html',
  styleUrls: ['./prod-order-dispatch.component.scss'],
  imports: [
    ProdOrderTransitBrowserComponent,
    ProdOrderTransitDetailComponent,
    AsyncPipe,
    ElderTranslatePipe,
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
    ElderPaneContentComponent,
    ElderPaneTitleComponent,
    ElderPaneHeaderComponent,
  ],
})
export class ProdOrderDispatchComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly logger = LoggerFactory.getLogger(this.constructor.name)

  public readonly selected$ = new BehaviorSubject<ProdOrderTransit>(null)

  @Input()
  public prodOrder: ProdOrder

  @Output()
  public readonly assignmentChange: EventEmitter<TransitAssignment> =
    new EventEmitter<TransitAssignment>()

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  public set selected(prodOrderTransit: ProdOrderTransit) {
    this.selected$.next(prodOrderTransit)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onTransitAssignmentChange(assignment: TransitAssignment) {
    this.assignmentChange.emit(assignment)
  }
}
